import * as angular from 'angular';

import extendDeep from './extendDeep';

// The controller is split out from within the directive for ease of testing purposes.
// See the actual benchmarksGraph directive at the bottom of the page.
export function GraphsBenchmarksGraphController($scope, BenchmarkGraph) {
  'ngInject';

  angular.extend(this, {
    init: function () {
      // defaults
      var defaultConfig = {
        benchmarkType: 'similar'
      };

      $scope.config = angular.extend({}, defaultConfig, $scope.config);

      // this should be moved out of init and to a separate class
      switch ($scope.config.templateName) {
        case 'contract-planning-mini':
          $scope.config.size = 'mini';
          break;
        case 'contract-planning-small':
          $scope.config.size = 'small';
          break;
        case 'contract-planning-modal':
        case 'benchmarks-plan-modal':
          $scope.config.size = 'modal';
          break;
        case 'contract-planning-summary':
          $scope.config.size = 'small';
          break;
        case 'group-impact-details':
          $scope.config.size = 'impact';
          break;
        case 'contract-planning-current-spend':
        case 'contract-planning-planned-spend':
          $scope.config.size = 'small';
          break;
      }
    },
    render: function () {
      $scope.render();
    }
  });

  angular.extend($scope, {
    highchart: {
      config: {
        chart: {}
      }
    },
    setBenchmarkType: function (type) {
      // Update benchmarkType then redraw the chart
      this.config.benchmarkType = type;
      this.$parent.$broadcast('redraw');
    },
    getBenchmarkTypeToggleText: function () {
      return this.config.benchmarkType == 'similar' ? 'all' : 'similar';
    },
    isSmall: function () {
      return this.config.size == 'small';
    },
    isMedium: function () {
      return this.config.size == 'medium';
    },
    isLarge: function () {
      return this.config.size == 'large';
    },
    render: function () {
      if (this.data) {
        let selectedBenchmark = this.data.benchmarks[this.config.benchmarkType];
        BenchmarkGraph.setSize(this.config.size);

        if (selectedBenchmark.currentRanking != null) {
          selectedBenchmark.currentRanking = Math.round(
            selectedBenchmark.currentRanking
          );
        }

        if (selectedBenchmark.plannedRanking != null) {
          selectedBenchmark.plannedRanking = Math.round(
            selectedBenchmark.plannedRanking
          );
        }

        var savingsAmount =
          typeof this.data.savingsAmount !== 'undefined'
            ? this.data.savingsAmount
            : null;

        BenchmarkGraph.setRankings(
          selectedBenchmark.currentRanking,
          selectedBenchmark.plannedRanking,
          savingsAmount,
          this.config.size
        );

        var self = this;

        if (this.config.showLargeGraphOnClick) {
          BenchmarkGraph.setGraphClickHandler(function () {
            self.showLargeGraph(self.config, self.data);
          });
        } else {
          BenchmarkGraph.setGraphClickHandler(null);
        }

        this.highchart.config = BenchmarkGraph.getHighchartConfig();
      }
    },
    isSavingsPositive: function () {
      return this.data.savingsAmount >= 0;
    },
    isSummaryVisible: function () {
      return this.config.showSummary || false;
    },
    areBenchmarkControlsVisible: function () {
      return this.config.showBenchmarkControls || false;
    },
    showLargeGraph: function (config, data) {
      this.$emit('showLargeGraph', config, data);
      //      console.log('SHOW LARGE GRAPHS');
    },
    extendDeep: extendDeep
  });

  this.init();
  this.render();

  $scope.$on('redraw', () => {
    this.init();
    this.render();
  });
}

export function BenchmarksGraphDirective(
  $http,
  $compile,
  BenchmarkGraph,
  $timeout
) {
  'ngInject';

  return {
    restrict: 'EA',
    replace: true,
    template: require('../benchmarks/benchmarks.html'),
    scope: {
      config: '=',
      data: '=stuff'
    },
    controller: 'GraphsBenchmarksGraphController'
  };
}
